import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { formatSwissDate, config } from 'components/Charts_Assets'
type xTickDataType = { text?: string[]; lines?: string[] }
export const XTicks = ({
  data,
  x,
  y
}: {
  data: xTickDataType
  x: ScaleLinear<string, string, never>
  y: ScaleLinear<number, number>
}) => {
  return (
    <>
      {data.lines &&
        data.lines.map((t, i) => {
          return (
            <line
              key={i}
              y1={y.range()[0] - 2}
              y2={y.range()[0] + 5}
              x1={x(new Date(t))}
              x2={x(new Date(t))}
              className='tickline'
            />
          )
        })}
      {data.text &&
        data.text.map((t, i) => {
          return (
            <text
              key={i}
              x={x(new Date(t))}
              y={y.range()[0] + config.textOffsetY}
              className='ticktext'
              textAnchor={i === 0 ? 'middle' : 'middle'}
            >
              {window.innerWidth < 600
                ? formatSwissDate(t, 'year_only')
                : formatSwissDate(t, 'year_only')}
            </text>
          )
        })}
    </>
  )
}
